import React from "react";

import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";

import Landpage from 'screens/Landpage'
import Landpage02 from 'screens/Landpage02' 
import NotFound from 'screens/NotFound' 

import Login from 'screens/Authentication/Login' 
import Register from 'screens/Authentication/Register' 
import Forgot from 'screens/Authentication/Forgot' 
import CreatePassword from 'screens/Authentication/CreatePassword' 

import DashboardSelectProfile from 'screens/Dashboard/SelectProfile' 
import DashboardCreateProfile from 'screens/Dashboard/CreateProfile' 
import DashboardHome from 'screens/Dashboard/Home' 
import DashboardModeSelection from 'screens/Dashboard/ModeSelection'
import DashboardLearning from 'screens/Dashboard/Learning'
import DashboardConversation from 'screens/Dashboard/Conversation'
import DashboardHistory from 'screens/Dashboard/History'
//import DashboardFavorites from 'screens/Dashboard/Favorites'
import DashboardDownloads from 'screens/Dashboard/Downloads'
//import DashboardGenImg from 'screens/Dashboard/GenImg'
//import DashboardRobo from 'screens/Dashboard/Robo'  
import DashboardCategory from 'screens/Dashboard/Category' 
//import DashboardSearch from 'screens/Dashboard/Search' 

import DashboardAbout from 'screens/Dashboard/About' 
import DashboardHelp from 'screens/Dashboard/Help' 
import DashboardSign from 'screens/Dashboard/Sign' 

import DashboardAccount from 'screens/Dashboard/Account' 
import DashboardAccountConfirmEmail from 'screens/Dashboard/Account/ConfirmEmail' 
import DashboardAccountChangeEmail from 'screens/Dashboard/Account/ChangeEmail' 
import DashboardAccountCreatePassword from 'screens/Dashboard/Account/CreatePassword' 
import DashboardAccountPlan from 'screens/Dashboard/Account/Plan' 
import DashboardAccountChangePlan from 'screens/Dashboard/Account/ChangePlan' 
import DashboardAccountCancelSubscription from 'screens/Dashboard/Account/CancelSubscription' 
import DashboardAccountChangeCreditCard from 'screens/Dashboard/Account/ChangeCreditCard'
import DashboardAccountMemory from 'screens/Dashboard/Account/Memory'

import DashboardChatBox from 'screens/Dashboard/ChatBox'
import DashboardChatBox02 from 'screens/Dashboard/ChatBox02'
import DashboardChatBox03 from 'screens/Dashboard/ChatBox03'
import DashboardChatBox04 from 'screens/Dashboard/ChatBox04'
import DashboardChatBox05 from 'screens/Dashboard/ChatBox05'
import DashboardChatBox06 from 'screens/Dashboard/ChatBox06'
import DashboardChatBox07 from 'screens/Dashboard/ChatBox07'
import DashboardChatBox08 from 'screens/Dashboard/ChatBox08'

import DashboardPlayer from 'screens/Dashboard/Player'
import DashboardPrivacityPolice from "screens/PrivacityPolice";

import TermsOfUse from "screens/Legal/TermsOfUse";
import PrivacyPolicy from "screens/Legal/PrivacyPolicy";

import CookieConsent from "components/CookieConsent";
import PWAInstallPrompt from "components/PWAInstallPrompt";

export default function AppRouter() {
    return (
      <Router>  
        <div>
          <Switch>
            <Route path="/" exact> <Landpage /> </Route>
            <Route path="/planos" exact> <Landpage02 /> </Route>

            <Route path="/termos-de-uso" exact> <TermsOfUse /> </Route>
            <Route path="/politica-de-privacidade" exact> <PrivacyPolicy /> </Route>
            
            <Route path="/login" exact> <Login /> </Route> 
            <Route path="/register" exact> <Register /> </Route> 
            <Route path="/forgot" exact> <Forgot /> </Route> 
            <Route path="/create-password" exact> <CreatePassword /> </Route> 
            
            {/* Nova estrutura de navegação */}
            <Route path="/dashboard" exact> <DashboardModeSelection /> </Route> 
            <Route path="/dashboard/mode-selection" exact> <DashboardModeSelection /> </Route>
            <Route path="/dashboard/learning" exact> <DashboardLearning /> </Route>
            <Route path="/dashboard/conversation" exact> <DashboardConversation /> </Route>
            <Route path="/dashboard/history" exact> <DashboardHistory /> </Route>
            <Route path="/dashboard/home" exact> <DashboardHome /> </Route>
            
            <Route path="/dashboard/select-profile" exact> <DashboardSelectProfile /> </Route> 
            <Route path="/dashboard/create-profile" exact> <DashboardCreateProfile /> </Route> 
            {/*<Route path="/dashboard/favorites" exact> <DashboardFavorites /> </Route>*/}
            <Route path="/dashboard/downloads" exact> <DashboardDownloads /> </Route>
            {/*<Route path="/dashboard/genimg" exact> <DashboardGenImg /> </Route>*/}
            {/*<Route path="/dashboard/robo" exact> <DashboardRobo /> </Route>*/} 
            
            {/* ChatBox originais para aprendizado */}
            <Route path="/dashboard/chatbox" exact> <DashboardChatBox /> </Route> 
            <Route path="/dashboard/chatbox02" exact> <DashboardChatBox02 /> </Route> 
            <Route path="/dashboard/chatbox03" exact> <DashboardChatBox03 /> </Route> 
            <Route path="/dashboard/chatbox04" exact> <DashboardChatBox04 /> </Route> 
            
            {/* Novos ChatBox para conversa livre */}
            <Route path="/dashboard/chatbox05" exact> <DashboardChatBox05 /> </Route> 
            <Route path="/dashboard/chatbox06" exact> <DashboardChatBox06 /> </Route> 
            <Route path="/dashboard/chatbox07" exact> <DashboardChatBox07 /> </Route> 
            <Route path="/dashboard/chatbox08" exact> <DashboardChatBox08 /> </Route> 
            
            <Route path="/dashboard/category/:slug" exact> <DashboardCategory /> </Route> 
            {/*<Route path="/dashboard/search" exact> <DashboardSearch /> </Route>*/} 
            
            <Route path="/dashboard/about" exact> <DashboardAbout /> </Route> 
            <Route path="/dashboard/help" exact> <DashboardHelp /> </Route> 
            <Route path="/dashboard/sign" exact> <DashboardSign /> </Route> 

            <Route path="/dashboard/account" exact> <DashboardAccount /> </Route> 
            <Route path="/dashboard/account/confirm-email" exact> <DashboardAccountConfirmEmail /> </Route> 
            <Route path="/dashboard/account/change-email" exact> <DashboardAccountChangeEmail /> </Route> 
            <Route path="/dashboard/account/create-password" exact> <DashboardAccountCreatePassword /> </Route> 
            <Route path="/dashboard/account/plan" exact> <DashboardAccountPlan /> </Route> 
            <Route path="/dashboard/account/change-plan" exact> <DashboardAccountChangePlan /> </Route> 
            <Route path="/dashboard/account/cancel-subscription" exact> <DashboardAccountCancelSubscription /> </Route> 
            <Route path="/dashboard/account/change-creditcard" exact> <DashboardAccountChangeCreditCard /> </Route>
            <Route path="/dashboard/account/memory" exact> <DashboardAccountMemory /> </Route>
            
            <Route path="/dashboard/player" exact> <DashboardChatBox /> </Route> 
            
            <Route path="/dashboard/player" exact> <DashboardPlayer /> </Route> 
            <Route path="/dashboard/player/:video_id" exact> <DashboardPlayer /> </Route> 
            <Route path="/dashboard/player/:video_id/:running" exact> <DashboardPlayer /> </Route> 
            <Route path="/privacity-police" exact> <DashboardPrivacityPolice /> </Route> 
            
            <Route path="*" exact> <NotFound /> </Route>
          </Switch>
          <CookieConsent />
          <PWAInstallPrompt />
        </div>
      </Router>
    );
}
